import { actionsStyles } from "@insite/content-library/Widgets/ProductList/ProductListActions";
import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { viewSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListViewSelect";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

columnsStyles.container = {
    gap: 0,
    css: css`
        margin-bottom: 15px;
    `,
};
columnsStyles.leftColumnGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        > div[class^="Wrapper"] {
            padding-right: 10%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding-right: 0;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        }
    `,
};
columnsStyles.rightColumnGridItem = {
    width: [12, 12, 9, 9, 9],
};
viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        padding-top: 5px;
        float: right;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        display: none;
                    `,
                    css`
                        padding-top: 15px;
                    `,
                    null,
                ],
                "max",
            );
        }}
    `,
};
listStyles.wrapper = {
    css: css`
        margin-top: 20px;
        border-top: none;
    `,
};
listStyles.cardList = {
    gridContainer: {
        gap: 0,
        css: css`
            background: ${getColor("common.accent")};
            margin-bottom: 15px;
            &[data-test-selector="productListCardContainerList"] {
                background: #fff;
                margin-bottom: 0;
            }
        `,
    },
};
listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
            border: 1px solid ${getColor("common.border")};
            margin-bottom: 15px;
        `,
    },
    gridItem: {
        css: css`
            border-bottom: none;
            margin-bottom: 15px;
        `,
    },
};
listStyles.cardContainerMultiColumnStyles = {
    gridItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            padding: 10px;
        `,
    },
    cardDivider: {
        css: css`
            padding: 10px 10px 0 10px;
            height: 100%;
            width: 100%;
            overflow: hidden;
            background: #fff;
            border: none;
        `,
    },
};
productCountStyles.wrapper = {
    css: css`
        margin-top: 8px;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        margin: 15px 0;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            );
        }}
    `,
};
productCountStyles.countText = {
    css: css`
        white-space: nowrap;
        font-weight: bold;
        margin-right: 5px;
    `,
};
productCountStyles.queryText = {
    css: css`
        white-space: normal;
        font-weight: bold;
    `,
};
actionsStyles.wrapper = {
    css: css`
        display: flex;
        width: 100%;
        flex-direction: column;
        section {
            padding: 0;
        }
    `,
};
actionsStyles.addToListWrapper = {
    css: css`
        margin-top: 10px;
        min-height: 2rem;
    `,
};
actionsStyles.addToCartWrapper = {
    css: css`
        display: flex;
        align-items: flex-end;
        margin-top: 7px;
    `,
};
